<app-dialog
	modalTitle="Erro ao listar beneficiários"
	titleButton="Tentar novamente"
	secTitleButton=""
	[secButton]="false"
	[asAlert]="true"
	[noMargins]="true"
	(dialogSave)="closeModal(true)"
	(dialogClose)="closeModal()"
>
	<p class="error-message">{{ errorMessage }}</p>
</app-dialog>
